import { Injectable, Inject } from '@angular/core';
import { IExternalService } from 'app/+common/contracts/external-service.contract';
import { HttpClient, HttpBackend, HttpHeaders } from '@angular/common/http';
import { Response, Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ExternalService implements IExternalService {

    private httpClient: HttpClient;
    private auth = ""
    constructor(handler: HttpBackend) {
        this.auth = localStorage.getItem("external-service-auth")
        this.httpClient = new HttpClient(handler);
    }

    private extractData(res: any) {
        let body = res; //.json();
        return body;// || {};
    }

    private handleError(error: Response | any) {
        // In a real world app, you might use a remote logging infrastructure
        let errMsg: string;
        if (error instanceof Response) {
            const body = error.json() || '';
            const err = body.error || JSON.stringify(body);
            errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
        }
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable.throw(errMsg);
    }

    jit40RegisterCount(url: string, params: any) {

        let httpHeaders = new HttpHeaders({
            'content-type' : 'application/json',
            'Authorization': this.auth
             });    
             let options = {
                headers: httpHeaders
             };    

        return this.httpClient
            .post(url, params, options)
            .map(this.extractData)
            .catch(this.handleError);
    }

}


// WEBPACK FOOTER //
// ./src/app/+core/common/services/external.service.ts